import { Icon, Intent } from "@blueprintjs/core"
import { ITagItem } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface ICheckBoxCardFieldProps {
   item: ITagItem
}
const CheckBoxCardField = ({item, ...props}: ICheckBoxCardFieldProps): JSX.Element => {
    return <div className='landing-checkbox-single-field medallion-padder'>
        { item.title }
        <Icon icon={ item.checked ? "tick" : "cross" } intent={ item.checked ? Intent.SUCCESS: Intent.DANGER } />
    </div>
}
export default CheckBoxCardField